// updateUserStreak.js 
import { doc, getDoc, updateDoc } from "firebase/firestore"; 
import { db } from "../firebase";
import { checkAndUpdateAchievements } from "./achievements";

export const updateUserStreak = async (userId) => {   
  const userStatsRef = doc(db, "userStats", userId);      
  
  try {     
    const userStatsDoc = await getDoc(userStatsRef);     
    if (userStatsDoc.exists()) {       
      const data = userStatsDoc.data();       
      const today = new Date().toISOString().split("T")[0];       
      const lastActivity = data.lastActivityDate;              
      
      // Skip update if already processed today
      if (lastActivity === today) {
        return {
          streak: data.points.streak || 0,
          bonusPoints: 0,
          milestoneReached: false
        };
      }
      
      // Get yesterday's date       
      const yesterday = new Date();       
      yesterday.setDate(yesterday.getDate() - 1);       
      const yesterdayStr = yesterday.toISOString().split("T")[0];              
      
      let newStreak = data.points.streak || 0;       
      let streakMilestones = data.achievements.streakMilestones || [];       
      let bonusPoints = 0;              
      
      // If user was active yesterday, increment streak       
      if (lastActivity === yesterdayStr) {         
        newStreak += 1;                  
        
        // Check for streak milestones (7, 30, 100 days)         
        const milestonePoints = {           
          7: 50,           
          30: 200,           
          100: 1000         
        };                  
        
        Object.entries(milestonePoints).forEach(([days, points]) => {           
          if (newStreak === parseInt(days) && !streakMilestones.includes(parseInt(days))) {             
            bonusPoints += points;             
            streakMilestones.push(parseInt(days));           
          }         
        });       
      } else {
        // If user wasn't active yesterday, reset streak to 1
        newStreak = 1;       
      }              
      
      const totalPoints = (data.points.total || 0) + bonusPoints;              
      
      await updateDoc(userStatsRef, {         
        "points.streak": newStreak,         
        "lastActivityDate": today,         
        "points.total": totalPoints,         
        "achievements.streakMilestones": streakMilestones       
      });
      
      // Check for streak achievements
      if (newStreak >= 3) {
        await checkAndUpdateAchievements(userId, 'STREAK_MILESTONES', newStreak);
      }
      
      // Return data that can be used for notifications       
      return {         
        streak: newStreak,         
        bonusPoints: bonusPoints,         
        milestoneReached: bonusPoints > 0       
      };     
    }
    return null;
  } catch (error) {     
    console.error("Error updating user streak:", error);     
    return null;   
  } 
};